module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment"
  }, [_c('h4', [_vm._v(_vm._s(_vm.comment.author.name))]), _vm._v(" "), _c('p', {
    staticClass: "commentMeta"
  }, [_vm._v(_vm._s(_vm.commentDate))]), _c('p'), _c('div', {
    staticClass: "commentContent",
    domProps: {
      "innerHTML": _vm._s(_vm.comment.content)
    }
  }), _vm._v(" "), (_vm.replying) ? _c('comment-form', {
    attrs: {
      "postId": _vm.postId,
      "parentId": _vm.comment.id,
      "child": true
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.replying && _vm.comment.depth < 5) ? _c('button', {
    staticClass: "button button-underline",
    on: {
      "click": _vm.toggleReply
    }
  }, [_vm._v("Reply")]) : _vm._e(), _vm._v(" "), (_vm.children) ? _c('div', [(_vm.children.length) ? _c('child-comments', {
    attrs: {
      "comments": _vm.children,
      "childComments": _vm.childComments,
      "postId": _vm.postId
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-506c16da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Comment.vue
// module id = 778
// module chunks = 1